
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Box, Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, Dialog, DialogActions, DialogContent, FormControl, TextField, InputAdornment, OutlinedInput, CircularProgress, InputLabel, MenuItem, Select, Paper, InputBase, ButtonGroup, Autocomplete, Checkbox, Chip, FormGroup, FormControlLabel, DialogTitle, Tooltip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SearchIcon from "@mui/icons-material/Search";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SettingsIcon from '@mui/icons-material/Settings';
import TuneIcon from '@mui/icons-material/Tune';
import GroupIcon from '@mui/icons-material/Group';
import LoginIcon from '@mui/icons-material/Login';

import moment from "moment";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { ObtenerDescripcionEntidad } from "../../helpers/ObtenerClaveEntidad";

import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { openSnackbar } from "../../store/slices/SnackbarSlice";
import { defaultRoles, stateProps } from "../../store/slices/AuthSlice";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";
import { InputSearchButtonsStyle, InputSearchStyle } from "../../styles/FormStyle";
import { DialogActionsStyle, DialogContentStyle, DialogSectionHeaderStyle, DialogSectionLabelStyle, DialogSectionStyle } from "../../styles/DialogStyle";

import { Layout } from "../../components/Layout"
import { SearchTextField } from "../../components/SearchTextField";

import { ActualizarConfiguracionUsuario, ActualizarMecanografosUsuario, ActualizarPermisosUsuario, ActualizarUsuario, AgregarUsuario, BuscarUsuarioRH, BuscarUsuariosDelegados, ObtenerMecanografos, Usuarios } from "../../connections/admin/UsuarioConnection";
import { EntrarComo } from "../../connections/auth/AuthConnection";
import { ObtenerTipoUsuarios } from "../../connections/catalogos/TipoUsuarioConnection";
import { ObtenerPuestos } from "../../connections/catalogos/PuestoConnection";
import { ObtenerRoles } from "../../connections/catalogos/RolConnection";
import { ObtenerAutoridades } from "../../connections/catalogos/AutoridadConnection";
import { ObtenerUnidad } from "../../connections/catalogos/UnidadConnection";

import { ActualizarConfiguracionUsuarioParams, ActualizarMecanografosUsuarioParams, ActualizarPermisosUsuarioParams, ActualizarUsuarioParams, AgregarUsuarioParams, MecanografoProps, RolUsuarioProps, UsuarioDelegadoProps, UsuarioProps } from "../../interfaces/admin/UsuarioInterface";
import { TipoUsuarioProps } from "../../interfaces/catalogos/TipoUsuarioInterface";
import { PuestoProps } from "../../interfaces/catalogos/PuestoInterface";
import { UnidadProps } from "../../interfaces/catalogos/UnidadInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";

type ActionType = 'Nuevo' | 'Buscar';

export const UsuariosPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [openDialogAgregar, setOpenDialogAgregar] = useState( false );
    const [openDialogEditar, setOpenDialogEditar] = useState( false );
    const [openDialogEditarConfiguracion, setOpenDialogEditarConfiguracion] = useState( false );
    const [openDialogEditarPermisos, setOpenDialogEditarPermisos] = useState( false );
    const [openDialogMecanografos, setOpenDialogMecanografos] = useState( false );

    const [showPassword, setShowPassword] = useState( false );

    const [loadingData, setLoadingData] = useState( true );
    const [loadingBuscar, setLoadingBuscar] = useState( false );
    const [loadingAgregar, setLoadingAgregar] = useState( false );
    const [loadingEditar, setLoadingEditar] = useState( false );
    const [loadingEditarConfiguracion, setLoadingEditarConfiguracion] = useState( false );
    const [loadingEditarPermisos, setLoadingEditarPermisos] = useState( false );
    const [loadingMecanografos, setLoadingMecanografos] = useState( false );
    const [idUsuarioEntrarComo, setIdUsuarioEntrarComo] = useState( 0 );

    const [idUsuario, setIdUsuario] = useState( 0 );
    const [usuarios, setUsuarios] = useState<UsuarioProps[]>( [] );

    const [nombres, setNombres] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [telefono, setTelefono] = useState( '' );
    const [contrasena, setContrasena] = useState( '' );
    const [curp, setCurp] = useState( '' );

    const [tipoUsuario, setTipoUsuario] = useState( 0 );
    const [tipoUsuarioArray, setTipoUsuarioArray] = useState<TipoUsuarioProps[]>( [] );

    const [curpBuscar, setCurpBuscar] = useState( '' );
    const [action, setAction] = useState<ActionType>( 'Buscar' );

    const [puesto, setPuesto] = useState( 0 );
    const [puestoArray, setPuestoArray] = useState<PuestoProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [idUsuarioExpedienteVirtual, setIdUsuarioExpedienteVirtual] = useState( 0 );

    const [idUsuarioFirmaElectronica, setIdUsuarioFirmaElectronica] = useState( 0 );
    const [contrasenaFirmaElectronica, setContrasenaFirmaElectronica] = useState( '' );
    const [fechaExpiracionFirmaElectronica, setFechaExpiracionFirmaElectronica] = useState( '' );
    const [viewContrasenaFirma, setViewContrasenaFirma] = useState( false );

    const [idUsuarioAgendamiento, setIdUsuarioAgendamiento] = useState( 0 );

    const [roles, setRoles] = useState<RolUsuarioProps[]>( [] );
    const [rolesSelected, setRolesSelected] = useState<RolUsuarioProps[]>( [] );

    const [mecanografos, setMecanografos] = useState<MecanografoProps[]>( [] );
    const [mecanografosTemp, setMecanografosTemp] = useState<MecanografoProps[]>( [] );
    const [mecanografosSelected, setMecanografosSelected] = useState<MecanografoProps[]>( [] );

    const [usuarioDelegado, setUsuarioDelegado] = useState( 0 );
    const [usuariosDelegados, setUsuariosDelegados] = useState<UsuarioDelegadoProps[]>( [] );

    const [unidad, setUnidad] = useState( 0 );
    const [unidadArray, setUnidadArray] = useState<UnidadProps[]>( [] );

    const [activo, setActivo] = useState( true );
    const [restablecerContrasena, setRestablecerContrasena] = useState( false );

    const [tieneFirma, setTieneFirma] = useState( false );
    const [delegarBandeja, setDelegarBandeja] = useState( false );
    const [vincularSistemas, setVincularSistemas] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( usuarios, ( item, filtro ) => {

        const nombreCompleto = `${ item.nombres } ${ item.apellido1 } ${ item.apellido2 ?? '' }`.toLowerCase();

        return nombreCompleto.includes( filtro.toLowerCase() );
    });

    const CURPFechaNacimiento = ( curp: string ) => {

        var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ ) ?? [];

        var anyo = parseInt(m[1],10) + 1900;

        if( anyo < 1950 ) anyo += 100;

        var mes = parseInt(m[2], 10)-1;
        var dia = parseInt(m[3], 10);

        return (new Date( anyo, mes, dia ));
    }

    const handleAgregarUsuario = async () => {

        const entidad = curp ? ObtenerDescripcionEntidad( curp.substring(11, 13) )?.estado : '';
        const fechaNacimiento = CURPFechaNacimiento( curp );
        const sexo = curp.substring(10, 11);

        const usuarioAdd: AgregarUsuarioParams = {
            nombres,
            apellido1,
            apellido2,
            correoElectronico,
            idTipoUsuario: tipoUsuario,
            curp,
            idPuesto: puesto,
            entidadNacimiento: entidad,
            fechaNacimiento: moment( fechaNacimiento).format('YYYY-MM-DD'),
            idSexo: sexo === 'H' ? 1 : 2,
        };

        setLoadingAgregar( true );

        await AgregarUsuario( usuarioAdd ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setUsuarios([ ...usuarios, resp ]);
                    setOpenDialogAgregar( false );
                    setShowPassword( false );
                    setLoadingAgregar( false );

                    dispatch( openSnackbar({ message: message, variant: 'success' }));

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingAgregar( false );

                }

            }, 700);

        });

    }

    const handleActualizarUsuario = async () => {

        setLoadingEditar( true );

        const entidad = curp ? ObtenerDescripcionEntidad( curp.substring(11, 13) )?.estado : '';
        const fechaNacimiento = CURPFechaNacimiento( curp );
        const sexo = curp.substring(10, 11);

        const usuarioUpdate: ActualizarUsuarioParams = {
            idUsuario: idUsuario,
            nombres,
            apellido1,
            apellido2,
            curp,
            idPuesto: puesto,
            entidadNacimiento: entidad,
            fechaNacimiento: moment( fechaNacimiento).format('YYYY-MM-DD'),
            idSexo: sexo === 'H' ? 1 : 2,
        };

        await ActualizarUsuario( usuarioUpdate ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( idUsuario ) {

                        const newArray = usuarios.map( item => {
                            if ( item.idUsuario === resp.idUsuario ) {
                                item = {
                                    ...resp
                                };
                            }
                            return item;
                        });

                        setUsuarios( newArray );
                        setOpenDialogEditar( false );
                        setLoadingEditar( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));

                    }
                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingEditar( false );

                }

            }, 700);

        });

    }

    const handleActualizarConfiguracionUsuario = async () => {

        setLoadingEditarConfiguracion( true );

        const usuarioUpdate: ActualizarConfiguracionUsuarioParams = {
            idUsuario: idUsuario,
            correoElectronico,
            telefono,
            contrasena,
            activo,
            restablecerContrasena,
            idUsuarioExpedienteVirtual: vincularSistemas ? idUsuarioExpedienteVirtual : 0,
            idUsuarioFirmaElectronica: tieneFirma ? idUsuarioFirmaElectronica : 0,
            contrasenaFirmaElectronica: tieneFirma ? contrasenaFirmaElectronica : '',
            fechaExpiracionFirmaElectronica: tieneFirma ? fechaExpiracionFirmaElectronica : '',
            idUsuarioAgendamiento: vincularSistemas ? idUsuarioAgendamiento : 0,
            idPuesto: puesto,
            idUnidad: unidad,
            idTipoUsuario: tipoUsuario,
            idUsuarioDelegado: delegarBandeja ? usuarioDelegado : 0,
            idAutoridad: autoridad,
        };

        await ActualizarConfiguracionUsuario( usuarioUpdate ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( idUsuario ) {

                        const newArray = usuarios.map( item => {
                            if ( item.idUsuario === resp.idUsuario ) {
                                item = {
                                    ...resp
                                };
                            }
                            return item;
                        });

                        setUsuarios( newArray );
                        setOpenDialogEditarConfiguracion( false );
                        setLoadingEditarConfiguracion( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));

                    }
                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingEditarConfiguracion( false );

                }

            }, 700);

        });

    }

    const handleActualizarPermisosUsuario = async () => {

        setLoadingEditarPermisos( true );

        const usuarioUpdate: ActualizarPermisosUsuarioParams = {
            idUsuario: idUsuario,
            roles: rolesSelected.map( ({ id }) => id )
        };

        await ActualizarPermisosUsuario( usuarioUpdate ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( idUsuario ) {

                        const newArray = usuarios.map( item => {
                            if ( item.idUsuario === resp.idUsuario ) {
                                item = {
                                    ...resp
                                };
                            }
                            return item;
                        });

                        setUsuarios( newArray );
                        setOpenDialogEditarPermisos( false );
                        setLoadingEditarPermisos( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));

                    }
                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingEditarPermisos( false );

                }

            }, 700);

        });

    }

    const handleEntrarComo = async ( usuario: UsuarioProps ) => {

        setIdUsuarioEntrarComo( usuario.idUsuario );

        await EntrarComo( { idUsuario: usuario.idUsuario } ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( !window.localStorage.getItem('dataAdministrador') ) {
                        window.localStorage.setItem('dataAdministrador', window.localStorage.getItem('data') ?? '');
                    }

                    const data: stateProps = {
                        nombres: resp?.nombres ?? '',
                        apellidos: resp?.apellidos ?? '',
                        token: resp?.token ?? '',
                        correoElectronico: resp?.correoElectronico ?? '',
                        administrador: resp.administrador ?? false,
                        coordinador: resp.coordinador ?? false,
                        restablecerContrasena: false,
                        idUnidad: resp.idUnidad ?? 0,
                        unidad: resp.unidad ?? '',
                        roles: resp.roles ?? defaultRoles,
                    };

                    window.localStorage.setItem('data', JSON.stringify(data));
                    window.location.replace( '/' );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setIdUsuarioEntrarComo( 0 );

                }

            }, 700);

        });

    }

    const handleActualizarMecanografosUsuario = async () => {

        setLoadingMecanografos( true );

        const usuarioUpdate: ActualizarMecanografosUsuarioParams = {
            idUsuario: idUsuario,
            mecanografos: mecanografosSelected.map( ({ idUsuario }) => idUsuario )
        };

        await ActualizarMecanografosUsuario( usuarioUpdate ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    if ( idUsuario ) {

                        const newArray = usuarios.map( item => {
                            if ( item.idUsuario === resp.idUsuario ) {
                                item = {
                                    ...resp
                                };
                            }
                            return item;
                        });

                        setUsuarios( newArray );
                        setOpenDialogMecanografos( false );
                        setLoadingMecanografos( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));

                    }
                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));

                    setLoadingMecanografos( false );

                }

            }, 700);

        });

    }

    const handleClose = () => {

        setIdUsuario( 0 );
        setCurp('');
        setCurpBuscar( '' );
        setNombres( '' );
        setApellido1( '' );
        setApellido2( '' )
        setCorreoElectronico( '' )
        setTelefono( '' );
        setContrasena( '' );
        setCurp( '' );
        setTipoUsuario( 0 );
        setPuesto( 0 );
        setUnidad( 0 );

        setShowPassword( false );
        setViewContrasenaFirma( false );

        setIdUsuarioFirmaElectronica( 0 );
        setContrasenaFirmaElectronica( '' );
        setFechaExpiracionFirmaElectronica( '' );
        setUsuarioDelegado( 0 );
        setIdUsuarioAgendamiento( 0 );

        setActivo( true );
        setRestablecerContrasena( true );

        setTieneFirma( false );
        setDelegarBandeja( false );
        setVincularSistemas( false );

        setRolesSelected( [] );
        setMecanografosSelected( [] );
    }

    const handleBuscarUsuario = async () => {

        if ( curpBuscar === '' ) {
            return false;
        }

        setLoadingBuscar( true );

        await BuscarUsuarioRH( curpBuscar ).then( resp => {

            if ( resp ) {

                const { success, nombres, apellido_Primero, apellido_Segundo, email, curp } = resp;

                if ( success ) {

                    setTimeout(() => {

                        setCurp( curp ?? '' );
                        setNombres( nombres ?? '' );
                        setApellido1( apellido_Primero ?? '' );
                        setApellido2( apellido_Segundo ?? '' );
                        setCorreoElectronico( email ?? '' );

                        setCurpBuscar('');

                        setLoadingBuscar( false );

                    }, 100);
                }
                else {

                    setCurp( '' );
                    setNombres( '' );
                    setApellido1( '' );
                    setApellido2( '' );
                    setCorreoElectronico( '' );

                    setLoadingBuscar( false );

                    dispatch( openSnackbar({ message: `No se encontro la persona con el CURP: ${ curpBuscar }`, variant: 'warning' }));
                }

            }

        });

    }

    const handleEditUsuario = ( { idUsuario, curp, nombres, apellido1, apellido2, correoElectronico, telefono, contrasena, idTipoUsuario, idPuesto, roles, idUsuarioFirmaElectronica, contrasenaFirmaElectronica, fechaExpiracionFirmaElectronica, idUsuarioDelegado, activo, restablecerContrasena, idUnidad, idUsuarioAgendamiento, idAutoridad, idUsuarioExpedienteVirtual, mecanografos }: UsuarioProps ) => {

        setIdUsuario( idUsuario );

        setCurp(curp ?? "");
        setNombres( nombres );
        setApellido1( apellido1 );
        setApellido2( apellido2  ?? "")
        setCorreoElectronico( correoElectronico )
        setTelefono( telefono ?? "" )
        setContrasena( contrasena );
        setTipoUsuario( idTipoUsuario );
        setPuesto( idPuesto );
        setAutoridad( idAutoridad );

        setIdUsuarioFirmaElectronica( idUsuarioFirmaElectronica );
        setContrasenaFirmaElectronica( contrasenaFirmaElectronica );
        setFechaExpiracionFirmaElectronica( fechaExpiracionFirmaElectronica );
        setUsuarioDelegado( idUsuarioDelegado );
        setIdUsuarioAgendamiento( idUsuarioAgendamiento );
        setUnidad( idUnidad );
        setIdUsuarioExpedienteVirtual( idUsuarioExpedienteVirtual );

        setActivo( activo );
        setRestablecerContrasena( restablecerContrasena );

        setTieneFirma( idUsuarioFirmaElectronica !== 0 );
        setDelegarBandeja( idUsuarioDelegado !== 0 );
        setVincularSistemas( idUsuarioExpedienteVirtual !== 0 || idUsuarioAgendamiento !== 0 );

        setMecanografosTemp( mecanografos );

        if ( roles.length !== 0 ) {

            const optionsDefault = roles.filter( ({ selected }) => { return selected === true; } );

            setRolesSelected( optionsDefault );

            setRoles( roles );
        }

    }

    useEffect(() => {

        async function obtener(){

            setLoadingData( true );
            setUsuarios( [] );

            await Usuarios().then( resp => {

                setTimeout(() => {

                    setUsuarios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])

    useEffect(() => {

        async function obtener(){

            await ObtenerTipoUsuarios().then( resp => {

                setTimeout(() => {

                    setTipoUsuarioArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])

    useEffect(() => {

        async function Obtener(){

            await ObtenerPuestos().then( resp => {
                setPuestoArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            await ObtenerUnidad().then( resp => {
                setUnidadArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            await ObtenerAutoridades().then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            await BuscarUsuariosDelegados().then( resp => {
                setUsuariosDelegados( resp );
            });
        }

        if ( openDialogEditarConfiguracion ) {
            Obtener();
        }

    }, [ openDialogEditarConfiguracion ]);

    useEffect(() => {

        async function Obtener(){

            await ObtenerRoles().then( resp => {

                const rolesArray: RolUsuarioProps[] = resp.map( ( { idRol, descripcion } ) => {
                    return {
                        id: idRol,
                        descripcion,
                        selected: false,
                    }
                });

                setRoles( rolesArray );

            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){

            setMecanografos( [] );
            setMecanografosSelected( [] );

            await ObtenerMecanografos( idUsuario ).then( resp => {

                setMecanografos( resp );

            });

        }

        if ( openDialogMecanografos && idUsuario !== 0 ) {
            Obtener();
        }

    }, [ openDialogMecanografos, idUsuario ]);

    useEffect(() => {

        if ( openDialogMecanografos && mecanografosTemp.length !== 0 && mecanografos.length !== 0 ) {
            setMecanografosSelected( mecanografosTemp );
        }

    }, [ openDialogMecanografos, mecanografos, mecanografosTemp ]);

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Usuarios' } ] } backgroundPaper={ false } >

            <Grid container spacing={ 3 } >

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        onClick={ () => {
                            handleClose();
                            setOpenDialogAgregar( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

                <Grid size={{ xs: 12 }} textAlign={ 'start' }>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por nombre del usuario"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}> Nombre completo </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Correo electrónico </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}> Tipo de usuario </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Firma <br /> electrónica </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( usuario, index ) => (

                                <TableRow key={ index } >

                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        <Chip
                                            label={ usuario.idUsuario }
                                            color={ usuario.activo ? 'primary' : 'error' }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Typography fontSize={ 14 } fontWeight={ 'bold' }>{ usuario.nombres.toUpperCase() } { usuario.apellido1.toUpperCase() } { usuario.apellido2?.toUpperCase() }</Typography>
                                        <Typography fontSize={ 12 } mt={ 1 }>{ usuario.curp }</Typography>
                                        {
                                            usuario.puesto
                                            &&
                                                <Typography fontSize={ 12 } mt={ 0.5 } color="textSecondary">Puesto: { usuario.puesto }</Typography>
                                        }
                                    </TableCell>

                                    <TableCell>
                                        { usuario.correoElectronico }
                                    </TableCell>

                                    <TableCell>
                                        { usuario.tipoUsuario }
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'center' }}>

                                        {
                                            usuario.idUsuarioFirmaElectronica !== 0
                                            &&
                                                <Chip
                                                    variant="filled"
                                                    color={ usuario.diasExpiraFirmaElectronica <= 0 ? 'error' : 'primary' }
                                                    sx={{ borderRadius: 3, py: 3, width: '100%' }}
                                                    label={
                                                        usuario.diasExpiraFirmaElectronica <= 0
                                                        ?
                                                            'Vencida o expirada.'
                                                        :
                                                            usuario.diasExpiraFirmaElectronica === 1
                                                            ?
                                                                <> Activa <br /> queda <strong>{ usuario.diasExpiraFirmaElectronica } dia.</strong> </>
                                                            :
                                                                <> Activa <br /> quedan <strong>{ usuario.diasExpiraFirmaElectronica } dia(s).</strong> </>
                                                    }
                                                />
                                        }

                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'end', whiteSpace: 'nowrap' }}>

                                        <Tooltip title="Información personal">
                                            <IconButton
                                                    color="primary"
                                                    component="span"
                                                    onClick={ () =>{ setOpenDialogEditar( true ); handleEditUsuario( usuario ); } }
                                                >
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Información de la cuenta">
                                            <IconButton
                                                    color="primary"
                                                    component="span"
                                                    sx={{ ml: 1 }}
                                                    onClick={ () =>{ setOpenDialogEditarConfiguracion( true ); handleEditUsuario( usuario ); } }
                                                >
                                                <SettingsIcon />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Permisos">
                                            <IconButton
                                                    color="primary"
                                                    component="span"
                                                    sx={{ ml: 1 }}
                                                    onClick={ () =>{ setOpenDialogEditarPermisos( true ); handleEditUsuario( usuario ); } }
                                                >
                                                <TuneIcon />
                                            </IconButton>
                                        </Tooltip>

                                        {
                                            usuario.idPuesto === 15
                                            &&
                                                <Tooltip title="Asignar mecanógrafos">
                                                    <IconButton
                                                            color="primary"
                                                            component="span"
                                                            sx={{ ml: 1 }}
                                                            onClick={ () =>{ setOpenDialogMecanografos( true ); handleEditUsuario( usuario ); } }
                                                        >
                                                        <GroupIcon />
                                                    </IconButton>
                                                </Tooltip>
                                        }

                                        <Tooltip title="Entrar como este usuario">
                                            <span>
                                                <IconButton
                                                        color="primary"
                                                        component="span"
                                                        sx={{ ml: 1 }}
                                                        disabled={ !usuario.activo || idUsuarioEntrarComo !== 0 }
                                                        onClick={ () => handleEntrarComo( usuario ) }
                                                    >
                                                    {
                                                        idUsuarioEntrarComo === usuario.idUsuario
                                                        ?
                                                            <CircularProgress size={ 24 } />
                                                        :
                                                            <LoginIcon />
                                                    }
                                                </IconButton>
                                            </span>
                                        </Tooltip>

                                    </TableCell>

                                </TableRow>

                            ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 6 } align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 6 } align="center">

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={ 2 } sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialogAgregar } fullWidth={ true } maxWidth='sm'>

                <DialogTitle>Agregar nuevo usuario</DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 }>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <ButtonGroup
                                disableElevation
                                fullWidth
                                size="small"
                                variant="text"
                            >
                                <Button variant={ action === 'Buscar' ? "contained" : "outlined" } onClick={ () => setAction( 'Buscar' ) }>
                                    Buscar en Sistema de RRHH
                                </Button>
                                <Button variant={ action === 'Nuevo' ? "contained" : "outlined" } onClick={ () => setAction( 'Nuevo' ) }>
                                    Agregar manualmente
                                </Button>
                            </ButtonGroup>

                        </Grid>

                        {
                            action === 'Buscar'
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >

                                        <InputBase
                                            placeholder="Buscar usuario"
                                            sx={{ ml: 1, flex: 1 }}
                                            value={ curpBuscar }
                                            onChange={ ( e ) => setCurpBuscar( e.target.value.toUpperCase() ) }
                                        />

                                        <Button
                                            type="button"
                                            variant='contained'
                                            size='small'
                                            sx={ InputSearchButtonsStyle }
                                            disabled={ curpBuscar.length < 18 }
                                            loading={ loadingBuscar }
                                            onClick={ handleBuscarUsuario }
                                        >
                                            <SearchIcon />
                                        </Button>

                                    </Paper>

                                </Grid>
                        }

                        <Grid size={{ xs: 12, md: 12 }}>

                            <TextField
                                fullWidth
                                label='Curp'
                                placeholder="XXXX000000XXXXXX00"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ curp }
                                onChange={ (e) => setCurp( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <TextField
                                fullWidth
                                label='Nombre(s)'
                                placeholder="Juan"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ nombres }
                                onChange={ (e) => setNombres( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Apellido 1'
                                placeholder="Perez"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ apellido1 }
                                onChange={ (e) => setApellido1( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Apellido 2'
                                placeholder="Perez"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ apellido2 }
                                onChange={ (e) => setApellido2( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel id="select-puesto-label">Puesto</InputLabel>

                                <Select
                                    labelId="select-puesto-label"
                                    id="select-puesto"
                                    label="Puesto"
                                    name="puesto"
                                    value={ puesto }
                                    onChange={ ( e ) => { setPuesto( parseInt( e.target.value.toString() ) ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        puestoArray.map( ( e ) => (
                                            <MenuItem key={ e.idPuesto } value={ e.idPuesto }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <TextField
                                fullWidth
                                label='Correo electrónico'
                                type="email"
                                placeholder="persona@pjecz.gob.mx"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ correoElectronico }
                                onChange={ (e) => setCorreoElectronico( e.target.value ) }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl required fullWidth>

                                <InputLabel id="select-tipoUsuario-label">Tipo de usuario</InputLabel>

                                <Select
                                    labelId="select-tipoUsuario-label"
                                    id="select-tipoUsuario"
                                    label="Tipo de usuario"
                                    name="tipoUsuario"
                                    value={ tipoUsuario }
                                    onChange={ ( e ) => { setTipoUsuario( parseInt( e.target.value.toString() ) ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoUsuarioArray.map( ( e ) => (
                                            <MenuItem key={ e.idTipoUsuario } value={ e.idTipoUsuario }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        disabled={ loadingAgregar }
                        onClick={ () => { setOpenDialogAgregar( false ); handleClose(); } }
                    >
                        Cancelar
                    </Button>

                    <Button
                        loading={ loadingAgregar }
                        disabled={ curp === '' || nombres === '' || apellido1 === '' || correoElectronico === '' || tipoUsuario === 0 }
                        variant='contained'
                        onClick={ handleAgregarUsuario }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openDialogEditar } fullWidth={ true } maxWidth='sm'>

                <DialogTitle>Información personal</DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } mt={ 1 }>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <TextField
                                fullWidth
                                label='Curp'
                                placeholder="XXXX000000XXXXXX00"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ curp }
                                onChange={ (e) => setCurp( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <TextField
                                fullWidth
                                label='Nombre(s)'
                                placeholder="Juan"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ nombres }
                                onChange={ (e) => setNombres( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Apellido 1'
                                placeholder="Perez"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ apellido1 }
                                onChange={ (e) => setApellido1( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Apellido 2'
                                placeholder="Perez"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ apellido2 }
                                onChange={ (e) => setApellido2( e.target.value ) }
                                disabled={ action === 'Buscar' && idUsuario === 0 }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel id="select-puesto-label">Puesto</InputLabel>

                                <Select
                                    labelId="select-puesto-label"
                                    id="select-puesto"
                                    label="Puesto"
                                    name="puesto"
                                    value={ puesto }
                                    onChange={ ( e ) => { setPuesto( parseInt( e.target.value.toString() ) ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        puestoArray.map( ( e ) => (
                                            <MenuItem key={ e.idPuesto } value={ e.idPuesto }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        disabled={ loadingEditar }
                        onClick={ () => { setOpenDialogEditar( false ); handleClose(); } }
                    >
                        Cancelar
                    </Button>

                    <Button
                        loading={ loadingEditar }
                        disabled={ curp === '' || nombres === '' || apellido1 === '' }
                        variant='contained'
                        onClick={ handleActualizarUsuario }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openDialogEditarConfiguracion } fullWidth={ true } maxWidth='md'>

                <DialogTitle>Información de la cuenta</DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } mt={ 1 }>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Autoridad</InputLabel>

                                <Select
                                    label="Autoridad"
                                    value={ autoridad }
                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        autoridadArray.map( ( e ) => (
                                            <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Correo electrónico'
                                type="email"
                                placeholder="persona@pjecz.gob.mx"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                                value={ correoElectronico }
                                onChange={ (e) => setCorreoElectronico( e.target.value ) }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <TextField
                                fullWidth
                                label='Teléfono'
                                placeholder="8440000000"
                                autoComplete="off"
                                variant="outlined"
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    },
                                    htmlInput: {
                                        maxLength: 10,
                                        inputMode: 'numeric'
                                    }
                                }}
                                value={ telefono }
                                onChange={ (e) => setTelefono( e.target.value.replace( /\D/g, '' ) ) }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink>Contraseña</InputLabel>
                                <OutlinedInput
                                    notched
                                    fullWidth
                                    label="Contraseña"
                                    placeholder="****************"
                                    autoComplete="current-password"
                                    type={ showPassword ? 'text' : 'password' }
                                    value={ contrasena }
                                    onChange={ (e) => setContrasena( e.target.value ) }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                size='small'
                                                aria-label={ showPassword ? 'hide the password' : 'display the password' }
                                                onClick={ () => setShowPassword( ( show ) => !show ) }
                                            >
                                                { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Tipo de usuario</InputLabel>

                                <Select
                                    label="Tipo de usuario"
                                    value={ tipoUsuario }
                                    onChange={ ( e ) => { setTipoUsuario( parseInt( e.target.value.toString() ) ); } }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoUsuarioArray.map( ( e ) => (
                                            <MenuItem key={ e.idTipoUsuario } value={ e.idTipoUsuario }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Unidad</InputLabel>

                                <Select
                                    label="Unidad"
                                    value={ unidad }
                                    onChange={ ( e ) => setUnidad( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        unidadArray.map( ( e ) => (
                                            <MenuItem key={ e.idUnidad } value={ e.idUnidad }>{ e.descripcion }</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormGroup>
                                <FormControlLabel
                                    control={ <Switch checked={ activo } onChange={ (e) => setActivo( e.target.checked ) } /> }
                                    label="Activar usuario"
                                />
                            </FormGroup>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormGroup>
                                <FormControlLabel
                                    control={ <Switch checked={ restablecerContrasena } onChange={ (e) => setRestablecerContrasena( e.target.checked ) } /> }
                                    label="Restablecer contraseña"
                                />
                            </FormGroup>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Box sx={ DialogSectionStyle }>

                                <Box sx={ DialogSectionHeaderStyle }>
                                    <Typography sx={ DialogSectionLabelStyle }>Asignar firma electrónica</Typography>
                                    <Switch checked={ tieneFirma } onChange={ (e) => setTieneFirma( e.target.checked ) } />
                                </Box>

                                {
                                    tieneFirma
                                    &&
                                    <Grid container spacing={ 3 }>

                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <TextField
                                                fullWidth
                                                label="ID Usuario Firma Electrónica"
                                                name="usuarioFirma"
                                                type="number"
                                                variant="outlined"
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                                value={ idUsuarioFirmaElectronica }
                                                onChange={ (e) => setIdUsuarioFirmaElectronica( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink>Contraseña Firma Electrónica</InputLabel>
                                                <OutlinedInput
                                                    notched
                                                    label="Contraseña Firma Electrónica"
                                                    name="contrasenaFirma"
                                                    placeholder="****************"
                                                    type={ viewContrasenaFirma ? 'text' : 'password' }
                                                    value={ contrasenaFirmaElectronica }
                                                    onChange={ (e) => setContrasenaFirmaElectronica( e.target.value ) }
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={ () => setViewContrasenaFirma( (prev) => !prev ) } edge="end" >
                                                                {
                                                                    viewContrasenaFirma
                                                                    ?
                                                                        <VisibilityOffIcon />
                                                                    :
                                                                        <VisibilityIcon />
                                                                }
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Fecha expiración de la Firma Electrónica"
                                                name="fechaExpiraFirma"
                                                type="date"
                                                variant="outlined"
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                                value={ fechaExpiracionFirmaElectronica }
                                                onChange={ ( e ) => setFechaExpiracionFirmaElectronica( e.target.value ) }
                                            />

                                        </Grid>

                                    </Grid>
                                }

                            </Box>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Box sx={ DialogSectionStyle }>

                                <Box sx={ DialogSectionHeaderStyle }>
                                    <Typography sx={ DialogSectionLabelStyle }>Delegar bandeja</Typography>
                                    <Switch checked={ delegarBandeja } onChange={ (e) => setDelegarBandeja( e.target.checked ) } />
                                </Box>

                                {
                                    delegarBandeja
                                    &&
                                    <Grid container spacing={ 3 }>

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <FormControl fullWidth>
                                                <InputLabel id="select-usuarioDelegado-label">Usuario delegado</InputLabel>

                                                <Select
                                                    labelId="select-usuarioDelegado-label"
                                                    id="select-usuarioDelegado"
                                                    label="Usuario delegado"
                                                    name="usuarioDelegado"
                                                    value={ usuarioDelegado }
                                                    onChange={ (e) => setUsuarioDelegado( e.target.value ) }
                                                >
                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                    {
                                                        usuariosDelegados.map( ( { idUsuario, nombreCompleto } ) => (
                                                            <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto.toUpperCase() }</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>

                                    </Grid>
                                }

                            </Box>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Box sx={ DialogSectionStyle }>

                                <Box sx={ DialogSectionHeaderStyle }>
                                    <Typography sx={ DialogSectionLabelStyle }>Vincular sistemas externos</Typography>
                                    <Switch checked={ vincularSistemas } onChange={ (e) => setVincularSistemas( e.target.checked ) } />
                                </Box>

                                {
                                    vincularSistemas
                                    &&
                                    <Grid container spacing={ 3 }>

                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <TextField
                                                fullWidth
                                                label="ID Usuario Poder en Línea (Expediente virtual)"
                                                name="usuarioTurnos"
                                                type="number"
                                                variant="outlined"
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                                value={ idUsuarioExpedienteVirtual }
                                                onChange={ (e) => setIdUsuarioExpedienteVirtual( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <TextField
                                                fullWidth
                                                label="ID Usuario Agendamiento"
                                                name="usuarioTurnos"
                                                type="number"
                                                variant="outlined"
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}
                                                value={ idUsuarioAgendamiento }
                                                onChange={ (e) => setIdUsuarioAgendamiento( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            />

                                        </Grid>

                                    </Grid>
                                }

                            </Box>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        disabled={ loadingEditarConfiguracion }
                        onClick={ () => { setOpenDialogEditarConfiguracion( false ); handleClose(); } }
                    >
                        Cancelar
                    </Button>

                    <Button
                        loading={ loadingEditarConfiguracion }
                        disabled={
                            tipoUsuario === 2
                            ?
                                correoElectronico === '' || contrasena === '' || ( tieneFirma && ( idUsuarioFirmaElectronica === 0 || contrasenaFirmaElectronica === '' || fechaExpiracionFirmaElectronica === '' ) ) || ( delegarBandeja && usuarioDelegado === 0 )
                            :
                                autoridad === 0 || correoElectronico === '' || contrasena === '' || tipoUsuario === 0 || ( tieneFirma && ( idUsuarioFirmaElectronica === 0 || contrasenaFirmaElectronica === '' || fechaExpiracionFirmaElectronica === '' ) ) || ( delegarBandeja && usuarioDelegado === 0 )
                        }
                        variant='contained'
                        onClick={ handleActualizarConfiguracionUsuario }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openDialogEditarPermisos } fullWidth={ true } maxWidth='md'>

                <DialogTitle>Permisos</DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } mt={ 1 }>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Autocomplete
                                multiple
                                id="select-roles"
                                value={ rolesSelected }
                                options={ roles }
                                onChange={ ( _, value ) => setRolesSelected( value ) }
                                disableCloseOnSelect
                                getOptionLabel={ (option) => option.descripcion }
                                renderOption={ (props, option, { selected }) => (
                                    <li { ...props } key={ option.descripcion } >
                                        <Checkbox
                                            icon={ <CheckBoxOutlineBlankIcon fontSize="small" /> }
                                            checkedIcon={ <CheckBoxIcon fontSize="small" /> }
                                            style={{ marginRight: 8 }}
                                            checked={ selected }
                                        />
                                        { option.descripcion }
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField { ...params } label="Selecciona los permisos" placeholder=""  />
                                )}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        disabled={ loadingEditarPermisos }
                        onClick={ () => { setOpenDialogEditarPermisos( false ); handleClose(); } }
                    >
                        Cancelar
                    </Button>

                    <Button
                        loading={ loadingEditarPermisos }
                        variant='contained'
                        onClick={ handleActualizarPermisosUsuario }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={ openDialogMecanografos } fullWidth={ true } maxWidth='md'>

                <DialogTitle>Asignar mecanografos</DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } mt={ 1 }>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Autocomplete
                                multiple
                                id="select-roles"
                                value={ mecanografosSelected }
                                options={ mecanografos }
                                onChange={ ( _, value ) => setMecanografosSelected( value ) }
                                disableCloseOnSelect
                                getOptionLabel={ (option) => option.usuario }
                                renderOption={ (props, option, { selected }) => (
                                    <li { ...props } key={ option.usuario } >
                                        <Checkbox
                                            icon={ <CheckBoxOutlineBlankIcon fontSize="small" /> }
                                            checkedIcon={ <CheckBoxIcon fontSize="small" /> }
                                            style={{ marginRight: 8 }}
                                            checked={ selected }
                                        />
                                        { option.usuario }
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField { ...params } label="Selecciona los mecanografos" placeholder=""  />
                                )}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button
                        color="secondary"
                        disabled={ loadingMecanografos }
                        onClick={ () => { setOpenDialogMecanografos( false ); handleClose(); } }
                    >
                        Cancelar
                    </Button>

                    <Button
                        loading={ loadingMecanografos }
                        variant='contained'
                        onClick={ handleActualizarMecanografosUsuario }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>

    )
}